export function generateRoomId() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let out = '';
  for (let i = 0; i < 6; i++) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return out;
}

export function generateUserId() {
  const random = Math.random().toString(36).slice(2, 10);
  return `user_${Date.now().toString(36)}${random}`;
}
